import { Box, BoxProps } from "@chakra-ui/react";
import { Link, Link_T, parseLinkProps } from "@ui/components/link";
import { PropsWithChildren } from "react";

type CircleLink_T = PropsWithChildren<Link_T & BoxProps>;

export const CircleLink = (props: CircleLink_T) => {
  const { linkProps, rest } = parseLinkProps(props);
  const { children, ...boxProps } = rest;

  return (
    <Link {...linkProps}>
      <Box
        bg="white"
        borderRadius="100%"
        boxSize="40px"
        borderWidth="2px"
        borderColor="blue.100"
        {...boxProps}
      >
        {children}
      </Box>
    </Link>
  );
};
